import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    button:{
        fontWeight: '700',
        fontSize: '14px',
        lineHeight: '137.5%',
        /* or 19px */
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        /* Grey/White */
        color: '#FFFFFF',
        width: '166px',
        height: '40px',
        borderRadius: '2px',
        background: '#7C9E3D',
        '&:hover': {
            background: "#AAC082",
         },
         '&:disabled': {
            background: "#B2B2B2",
         },
        border: 'none',
        
    }
}));

export default useStyles;
